export default __webpack_public_path__ + "static/media/slide_dev_transparent.12e9c886.png";